import React, { useState } from "react";
import { ScanLine, Zap, CheckCircle2, AlertTriangle, Timer } from "lucide-react";
import { api } from "../../services/api";

const PLATES = ["DL01AB1234", "UP16GH3456", "DL01CD5678", "HR26EF9012", "HR55LM2468"];

export default function RVAnpr() {
  const [plate, setPlate] = useState("DL01AB1234");
  const [res, setRes] = useState(null);
  const [scanning, setScanning] = useState(false);

  const run = async (p) => {
    setScanning(true); setRes(null);
    await new Promise((r) => setTimeout(r, 650));
    const d = await api.rvLookup(p);
    setRes(d); setScanning(false);
  };

  return (
    <div className="rv-anpr" data-testid="rv-anpr-page">
      <div className="vans-eyebrow" style={{ color: "#b91c1c" }}>IGL · Refuel Validation · Station Lane</div>
      <h1 className="vans-title" style={{ margin: "4px 0 6px" }}>ANPR Lane — Fast Pre-Check</h1>
      <p className="vans-sub" style={{ maxWidth: 720, marginBottom: 18 }}>
        As a vehicle approaches, ANPR reads the plate and the station does a single fast lookup against DotIQ's
        pre-computed state — no multi-system investigation at the dispenser.
      </p>

      <div className="ff-picker">
        <div className="ff-picker-h"><ScanLine size={16} style={{ verticalAlign: "-3px" }} /> Simulate an ANPR read at the station</div>
        <div className="ff-order-row">
          <select value={plate} onChange={(e) => setPlate(e.target.value)} data-testid="rv-anpr-plate">
            {PLATES.map((p) => <option key={p} value={p}>{p}</option>)}
          </select>
          <button className="btn-primary" onClick={() => run(plate)} disabled={scanning} data-testid="rv-anpr-run">
            <Zap size={16} /> {scanning ? "Reading plate…" : "Read plate"}
          </button>
        </div>
      </div>

      {scanning && <div className="loading-page">ANPR → plate recognised → DotIQ pre-computed state lookup…</div>}

      {res && (
        <div className={`rv-lane-result ${res.clear ? "clear" : "stop"}`} data-testid="rv-anpr-result">
          <div className="rv-lane-plate">{res.plate}</div>
          <div className="rv-lane-state">
            {res.clear ? <CheckCircle2 size={22} /> : <AlertTriangle size={22} />}
            <span style={{ color: res.state_meta?.color }}>{res.found ? res.state : "NOT FOUND"}</span>
          </div>
          <div className="rv-lane-msg">{res.message}</div>
          {res.found && (
            <div className="rv-lane-cfg">
              <span>Expected {`{${(res.expected || []).join(",")}}`}</span>
              <span>Observed {`{${(res.observed || []).join(",") || "—"}}`}</span>
            </div>
          )}
          <div className="rv-lane-ms"><Timer size={14} /> Lookup: {res.ms} ms</div>
          <div className="rv-lane-next">{res.clear ? "Continue normal IGL refueling process." : "Divert to IGL verification before refueling."}</div>
        </div>
      )}
    </div>
  );
}
